export var DeviceControlFeature;
(function (DeviceControlFeature) {
    DeviceControlFeature[DeviceControlFeature["TurnOn"] = 0] = "TurnOn";
    DeviceControlFeature[DeviceControlFeature["TurnOff"] = 1] = "TurnOff";
    DeviceControlFeature[DeviceControlFeature["ToggleState"] = 2] = "ToggleState";
    DeviceControlFeature[DeviceControlFeature["SetBlindPosition"] = 3] = "SetBlindPosition";
    DeviceControlFeature[DeviceControlFeature["SetLightColor"] = 4] = "SetLightColor";
    DeviceControlFeature[DeviceControlFeature["SetLightTemperature"] = 5] = "SetLightTemperature";
    DeviceControlFeature[DeviceControlFeature["SetLightBrightness"] = 6] = "SetLightBrightness";
    DeviceControlFeature[DeviceControlFeature["SetTemperature"] = 7] = "SetTemperature";
    DeviceControlFeature[DeviceControlFeature["GetState"] = 8] = "GetState";
    DeviceControlFeature[DeviceControlFeature["TurnOnWithTimeout"] = 9] = "TurnOnWithTimeout";
    DeviceControlFeature[DeviceControlFeature["SetLightBrightnessDynamicly"] = 10] = "SetLightBrightnessDynamicly";
    DeviceControlFeature[DeviceControlFeature["IdentifyDevice"] = 11] = "IdentifyDevice";
    DeviceControlFeature[DeviceControlFeature["SetBlindOpenCloseTime"] = 12] = "SetBlindOpenCloseTime";
    DeviceControlFeature[DeviceControlFeature["SetBlindMicroventilation"] = 13] = "SetBlindMicroventilation";
    //SetGatePosition = 14,
    //OpenGate = 15,
    //CloseGate = 16,
    //SetGatePositionPercentage = 17,
    //GateOn = 18,
    //GateOff = 19,
    //OpenGateway = 20,
    //CloseGateway = 21,
    //SetGatewayPositionPercentage = 22,
    //GatewayOn = 23,
    //GatewayOff = 24,
    DeviceControlFeature[DeviceControlFeature["GatewayPulse"] = 25] = "GatewayPulse";
    DeviceControlFeature[DeviceControlFeature["GatePulse"] = 26] = "GatePulse";
    //SetFacadePosition = 27,
    //SetFacadeTilt = 28,
    DeviceControlFeature[DeviceControlFeature["SetFacadePositionAndTilt"] = 29] = "SetFacadePositionAndTilt";
    DeviceControlFeature[DeviceControlFeature["GetFacadeType"] = 30] = "GetFacadeType";
    DeviceControlFeature[DeviceControlFeature["LightRGBW"] = 31] = "LightRGBW";
    DeviceControlFeature[DeviceControlFeature["SetGatePositionPrecise"] = 32] = "SetGatePositionPrecise";
    DeviceControlFeature[DeviceControlFeature["SetGatePositionPreciseSecure"] = 33] = "SetGatePositionPreciseSecure";
})(DeviceControlFeature || (DeviceControlFeature = {}));
//# sourceMappingURL=IDeviceTask.js.map